<template>
  <div
    :class="[`border-box--${ type }`, { 'border-box--xs-hide': xsHide }]"
    class="border-box"
  >
    <slot/>
  </div>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      default: 'normal',
      validator: propValue => ['normal', 'secondary'].includes(propValue)
    },
    xsHide: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
  .border-box {
    margin-top: -$border-width;
    padding-top: $vertical-space;
    border-top: $border-width solid;
    @include theme(border-color);

    &--secondary {
      @include vertical-space((top: .5), padding)
    }

    &--normal {
      @include vertical-space((top: 1), padding)
    }

    &--xs-hide {
      @include media-down(md) {
        margin-top: 0;
        padding-top: 0;
        border: none;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/BorderBox.vue